// Dark mode'u varsayılan yap
document.documentElement.classList.add('dark');

// Loading screen management - Minimum display time
(function() {
  const startTime = Date.now();
  const minDisplayTime = 800; // Minimum 800ms göster
  let hideScheduled = false;
  let lottieAnimation = null;
  
  // Initialize Lottie animation
  function initLottie() {
    const lottieContainer = document.getElementById('lottie-container');
    if (lottieContainer && typeof lottie !== 'undefined') {
      try {
        const loadingPath = '//winkink.net/cdn/shop/t/9/assets/loading.json?v=89326284770058207341764706671';
        lottieAnimation = lottie.loadAnimation({
          container: lottieContainer,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: loadingPath
        });
      } catch (error) {
        console.error('Lottie animation error:', error);
        // If Lottie fails, continue without animation
      }
    } else if (lottieContainer && typeof lottie === 'undefined') {
      // Lottie library not loaded yet, try again after a delay
      setTimeout(initLottie, 100);
    }
  }
  
  // Start Lottie animation when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLottie);
  } else {
    initLottie();
  }
  
  function forceHideLoading() {
    if (hideScheduled) return; // Prevent multiple calls
    hideScheduled = true;
    
    const elapsed = Date.now() - startTime;
    const remainingTime = Math.max(0, minDisplayTime - elapsed);
    
    setTimeout(() => {
      const loadingScreen = document.getElementById('loading-screen');
      if (loadingScreen) {
        // Stop Lottie animation
        if (lottieAnimation) {
          try {
            lottieAnimation.destroy();
          } catch (e) {
            console.error('Lottie destroy error:', e);
          }
        }
        
        // Hide with smooth transition
        loadingScreen.classList.add('hidden');
        
        // Force hide after transition
        setTimeout(() => {
          if (loadingScreen) {
            loadingScreen.style.display = 'none';
            loadingScreen.style.visibility = 'hidden';
            loadingScreen.style.opacity = '0';
            loadingScreen.style.pointerEvents = 'none';
            loadingScreen.style.zIndex = '-1';
            
            // Remove from DOM
            setTimeout(() => {
              if (loadingScreen && loadingScreen.parentNode) {
                loadingScreen.remove();
              }
            }, 100);
          }
        }, 300);
      }
      
      // Force enable scroll
      if (document.body) {
        document.body.classList.remove('loading');
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.height = '';
        document.body.style.width = '';
        document.body.style.touchAction = 'pan-y';
        document.documentElement.style.overflow = '';
        document.documentElement.style.touchAction = 'pan-y';
      }
    }, remainingTime);
  }
  
  // Hide when DOM is ready (but respect minimum time)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceHideLoading);
  } else {
    // DOM already ready
    forceHideLoading();
  }
  
  // Also listen for window load
  window.addEventListener('load', forceHideLoading);
  
  // Fallback - hide after max 2 seconds regardless
  setTimeout(forceHideLoading, 2000);
})();

// Remove overlay - it's causing scroll issues
(function() {
  function removeOverlay() {
const overlay = document.querySelector('.video-scroll-overlay');
if (overlay) {
  overlay.remove();
}
  }
  
  // Remove overlay immediately
  removeOverlay();
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', removeOverlay);
  }
  
  // Run on window load
  window.addEventListener('load', removeOverlay);
})();

// Typewriter animasyonu
const texts = [
  'BİR STİL İFADESİ.',
  'BİR SANAT ESERİ.',
  'BİR KİŞİLİK YANSIMASI.',
  'BİR ÖZGÜRLÜK HAREKETİ.',
  'BİR YARATICILIK ŞÖLENİ.'
];

let textIndex = 0;
let charIndex = 0;
let isDeleting = false;

function typeWriter() {
  const typewriterElement = document.getElementById('typewriter-text');
  if (!typewriterElement) return;
  
  const currentText = texts[textIndex];
  
  if (isDeleting) {
typewriterElement.textContent = currentText.substring(0, charIndex - 1);
charIndex--;
  } else {
typewriterElement.textContent = currentText.substring(0, charIndex + 1);
charIndex++;
  }
  
  let typeSpeed = isDeleting ? 50 : 100;
  
  if (!isDeleting && charIndex === currentText.length) {
typeSpeed = 2000; // Metin tamamlandığında 2 saniye bekle
isDeleting = true;
  } else if (isDeleting && charIndex === 0) {
isDeleting = false;
textIndex = (textIndex + 1) % texts.length;
typeSpeed = 500; // Yeni metne geçmeden önce kısa bekle
  }
  
  setTimeout(typeWriter, typeSpeed);
}

// Sayfa yüklendiğinde animasyonu başlat
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', typeWriter);
} else {
  setTimeout(typeWriter, 500);
}

// Sticker.js başlatma
function initSticker() {
  if (typeof Sticker !== 'undefined') {
Sticker.init('#bull-sticker-1');
Sticker.init('#bull-sticker-2');
Sticker.init('#bull-sticker-3');

// Mask'ları sadece gerekli elementlere uygula - peel efektini korumak için
function applyMasks() {
  const bullStickers = ['#bull-sticker-1', '#bull-sticker-2', '#bull-sticker-3'];
  bullStickers.forEach(function(stickerId) {
    const sticker = document.querySelector(stickerId);
    if (sticker) {
      const wrapper = sticker.querySelector('.sticker-wrapper');
      const img = sticker.querySelector('.sticker-img');
      const peel = sticker.querySelector('.sticker-peel');
      const shadow = sticker.querySelector('.sticker-shadow');
      
      [wrapper, img, peel, shadow].forEach(function(el) {
        if (el) {
          const ufoPngUrl = '//winkink.net/cdn/shop/t/9/assets/images/ufo.png?v=7048695870416330261764706671';
          el.style.setProperty('-webkit-mask-image', "url('" + ufoPngUrl + "')", 'important');
          el.style.setProperty('-webkit-mask-size', 'contain', 'important');
          el.style.setProperty('-webkit-mask-repeat', 'no-repeat', 'important');
          el.style.setProperty('-webkit-mask-position', 'center', 'important');
          el.style.setProperty('-webkit-mask-mode', 'alpha', 'important');
          el.style.setProperty('mask-image', "url('" + ufoPngUrl + "')", 'important');
          el.style.setProperty('mask-size', 'contain', 'important');
          el.style.setProperty('mask-repeat', 'no-repeat', 'important');
          el.style.setProperty('mask-position', 'center', 'important');
          el.style.setProperty('mask-mode', 'alpha', 'important');
          if (el !== peel) {
            el.style.setProperty('background-color', 'transparent', 'important');
          }
          if (wrapper) {
            wrapper.style.setProperty('overflow', 'visible', 'important');
          }
        }
      });
    }
  });
}

setTimeout(applyMasks, 300);
setTimeout(applyMasks, 600);
  }
  
  // Masonry Layout
  function initMasonry() {
const container = document.getElementById('masonry-container');
if (!container) return;

const items = Array.from(container.querySelectorAll('[data-masonry-item]'));
if (items.length === 0) return;

const gap = 24;

function getColumns() {
  const width = window.innerWidth;
  if (width >= 1024) return 3;
  if (width >= 640) return 2;
  return 1;
}

function layoutMasonry() {
  const columns = getColumns();
  const containerRect = container.getBoundingClientRect();
  const containerWidth = containerRect.width;
  // On mobile, reduce item width and add extra padding
  const isMobile = window.innerWidth < 640;
  const extraPadding = isMobile ? 32 : 0; // 16px on each side
  const maxItemWidth = isMobile ? 400 : 466;
  const itemWidth = Math.min(maxItemWidth, (containerWidth - (columns - 1) * gap - extraPadding) / columns);
  const itemHeight = 491;
  const columnWidth = itemWidth;
  
  // Set container to relative
  container.style.position = 'relative';
  
  // Calculate total width of all columns
  const totalWidth = columns * columnWidth + (columns - 1) * gap;
  const offsetLeft = (containerWidth - totalWidth) / 2;
  
  // Initialize column heights - start with different values to break top alignment
  const columnHeights = [];
  for (let i = 0; i < columns; i++) {
    columnHeights.push(i * 50); // Offset each column by 50px to break alignment
  }
  
  // Calculate positions based on fixed item dimensions
  items.forEach((item) => {
    // Find shortest column
    const shortestColumnIndex = columnHeights.indexOf(Math.min(...columnHeights));
    const left = offsetLeft + shortestColumnIndex * (columnWidth + gap);
    const top = columnHeights[shortestColumnIndex];
    
    item.style.cssText = `
      position: absolute;
      width: ${itemWidth}px;
      height: ${itemHeight}px;
      left: ${left}px;
      top: ${top}px;
      border-radius: 25px;
    `;
    
    columnHeights[shortestColumnIndex] += itemHeight + gap;
  });
  
  const maxHeight = Math.max(...columnHeights);
  container.style.height = maxHeight + 'px';
}

// Wait for all images to load
const images = Array.from(container.querySelectorAll('img'));
let loadedImages = 0;

function checkAllLoaded() {
  loadedImages++;
  if (loadedImages === images.length) {
    setTimeout(layoutMasonry, 200);
  }
}

if (images.length === 0) {
  setTimeout(layoutMasonry, 100);
} else {
  images.forEach((img) => {
    if (img.complete && img.naturalHeight > 0) {
      checkAllLoaded();
    } else {
      img.addEventListener('load', checkAllLoaded);
      img.addEventListener('error', checkAllLoaded);
    }
  });
}

window.addEventListener('resize', () => {
  clearTimeout(window.masonryResizeTimeout);
  window.masonryResizeTimeout = setTimeout(layoutMasonry, 150);
});
  }
  
  if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(initMasonry, 300);
});
  } else {
setTimeout(initMasonry, 300);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSticker);
} else {
  setTimeout(initSticker, 100);
}

// Testimonial Carousel
function initTestimonialCarousel() {
  const slides = document.querySelectorAll('.testimonial-slide');
  const upButton = document.getElementById('testimonial-up');
  const downButton = document.getElementById('testimonial-down');
  const leftButtonMobile = document.getElementById('testimonial-left-mobile');
  const rightButtonMobile = document.getElementById('testimonial-right-mobile');
  
  if (slides.length === 0) {
    console.warn('No testimonial slides found');
    return;
  }
  
  let currentIndex = 0;
  
  function showSlide(index) {
    const isMobile = window.innerWidth <= 768;
    
    if (isMobile) {
      // Mobile: horizontal scroll
      const slidesContainer = document.querySelector('.testimonial-slides');
      if (slidesContainer) {
        const firstSlide = slidesContainer.querySelector('.testimonial-slide');
        const slideWidth = firstSlide ? firstSlide.offsetWidth : slidesContainer.offsetWidth;
        slidesContainer.scrollTo({
          left: slideWidth * index,
          behavior: 'smooth'
        });
      }
    } else {
      // Desktop: vertical animation
      slides.forEach((slide, i) => {
        if (i === index) {
          slide.classList.remove('leaving');
          slide.classList.add('active');
          currentIndex = index;
        } else {
          slide.classList.remove('active');
          slide.classList.remove('leaving');
          if (i < index) {
            slide.classList.add('leaving');
          }
        }
      });
    }
    
    currentIndex = index;
  }
  
  function nextSlide() {
    currentIndex = (currentIndex + 1) % slides.length;
    showSlide(currentIndex);
  }
  
  function prevSlide() {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    showSlide(currentIndex);
  }
  
  if (upButton) {
    upButton.addEventListener('click', function(e) {
      e.preventDefault();
      prevSlide();
    });
  } else {
    console.warn('Testimonial up button not found');
  }
  
  if (downButton) {
    downButton.addEventListener('click', function(e) {
      e.preventDefault();
      nextSlide();
    });
  } else {
    console.warn('Testimonial down button not found');
  }
  
  // Mobile navigation buttons - left/right
  if (leftButtonMobile) {
    leftButtonMobile.addEventListener('click', function(e) {
      e.preventDefault();
      prevSlide();
    });
  }
  
  if (rightButtonMobile) {
    rightButtonMobile.addEventListener('click', function(e) {
      e.preventDefault();
      nextSlide();
    });
  }
  
  // Mobile touch swipe and scroll tracking
  const slidesContainer = document.querySelector('.testimonial-slides');
  if (slidesContainer) {
    // Update currentIndex on scroll (for mobile)
    slidesContainer.addEventListener('scroll', function() {
      if (window.innerWidth <= 768) {
        const firstSlide = slidesContainer.querySelector('.testimonial-slide');
        if (firstSlide) {
          const slideWidth = firstSlide.offsetWidth;
          const scrollLeft = slidesContainer.scrollLeft;
          const newIndex = Math.round(scrollLeft / slideWidth);
          if (newIndex !== currentIndex && newIndex >= 0 && newIndex < slides.length) {
            currentIndex = newIndex;
          }
        }
      }
    }, { passive: true });
    
    // Touch swipe handlers
    if (window.innerWidth <= 768) {
      let touchStartX = 0;
      let touchEndX = 0;
      
      slidesContainer.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      
      slidesContainer.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }, { passive: true });
      
      function handleSwipe() {
        const swipeThreshold = 50;
        const diff = touchStartX - touchEndX;
        
        if (Math.abs(diff) > swipeThreshold) {
          if (diff > 0) {
            // Swipe left - next
            nextSlide();
          } else {
            // Swipe right - previous
            prevSlide();
          }
        }
      }
    }
  }
  
  // Initialize first slide
  showSlide(0);
  
  console.log('Testimonial carousel initialized with', slides.length, 'slides');
}

// Prevent auto-scroll on page load - but don't force scroll to top
if (typeof window !== 'undefined') {
  // Prevent any hash-based scrolling
  window.addEventListener('load', () => {
// Prevent any hash-based scrolling
if (window.location.hash) {
  window.history.replaceState(null, null, ' ');
}
  });
  
  // Prevent focus from causing scroll
  document.addEventListener('DOMContentLoaded', () => {
// Prevent any element from auto-focusing
const focusedElement = document.activeElement;
if (focusedElement && focusedElement !== document.body) {
  focusedElement.blur();
}
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTestimonialCarousel);
} else {
  setTimeout(initTestimonialCarousel, 100);
}

// Tattoo Price Calculator Function
function calculateTattooPrice({
  widthCm,
  heightCm,
  quantity = 1,
  sheetCostTl = 115,
  sheetWidthMm = 210,
  sheetHeightMm = 297,
  markupFactor = 26.1,
  minUnitPriceTl = 300,
  roundTo = 10, // 10 TL'ye yuvarla
} = {}) {
  if (!widthCm || !heightCm || widthCm <= 0 || heightCm <= 0) {
    throw new Error("Width and height must be positive numbers.");
  }
  
  const widthMm = widthCm * 10;
  const heightMm = heightCm * 10;
  
  let fitX = Math.floor(sheetWidthMm / widthMm);
  let fitY = Math.floor(sheetHeightMm / heightMm);
  
  if (fitX < 1) fitX = 1;
  if (fitY < 1) fitY = 1;
  
  let maxPerSheet = fitX * fitY;
  if (maxPerSheet < 1) maxPerSheet = 1;
  
  const unitCost = sheetCostTl / maxPerSheet;
  const rawUnitPrice = unitCost * markupFactor;
  
  let unitPrice = Math.max(rawUnitPrice, minUnitPriceTl);
  
  if (roundTo && roundTo > 0) {
    unitPrice = Math.round(unitPrice / roundTo) * roundTo;
  }
  
  const qty = quantity && quantity > 0 ? quantity : 1;
  const totalPrice = unitPrice * qty;
  
  const sheetsNeeded = Math.ceil(qty / maxPerSheet);
  const totalProductionCost = sheetsNeeded * sheetCostTl;
  const profitEstimate = totalPrice - totalProductionCost;
  
  return {
    widthCm,
    heightCm,
    quantity: qty,
    fitX,
    fitY,
    maxPerSheet,
    unitCost,
    rawUnitPrice,
    unitPrice,
    totalPrice,
    sheetsNeeded,
    totalProductionCost,
    profitEstimate,
  };
}

// Make function globally available
window.calculateTattooPrice = calculateTattooPrice;

// Safari collection card click fix
document.addEventListener('DOMContentLoaded', function() {
  const collectionCards = document.querySelectorAll('.collection-card');
  
  collectionCards.forEach(function(card) {
    const href = card.getAttribute('href') || card.getAttribute('data-href');
    
    if (!href || href === '#') return;
    
    // Add click event for Safari compatibility
    card.addEventListener('click', function(e) {
      // Only intercept if it's Safari
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      if (isSafari) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = href;
        return false;
      }
    }, false);
    
    // Also add touchstart for mobile Safari
    card.addEventListener('touchend', function(e) {
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      if (isSafari) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = href;
        return false;
      }
    }, false);
  });
});

// Tüm sayfadaki ₺ simgelerini "TL" yazısı ile değiştir
document.addEventListener('DOMContentLoaded', function() {
  function replaceCurrencySymbols() {
    // Tüm elementleri bul ve içindeki ₺ simgelerini "TL" ile değiştir
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );
    
    const textNodes = [];
    let node;
    while (node = walker.nextNode()) {
      if (node.textContent.includes('₺')) {
        textNodes.push(node);
      }
    }
    
    textNodes.forEach(textNode => {
      textNode.textContent = textNode.textContent.replace(/₺/g, 'TL');
    });
  }
  
  // Sayfa yüklendiğinde çalıştır
  replaceCurrencySymbols();
  
  // Dinamik içerik için MutationObserver ekle
  const observer = new MutationObserver(function(mutations) {
    replaceCurrencySymbols();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// Mobile Menu Functions
function openMobileMenu() {
  const menu = document.getElementById('mobile-menu');
  if (menu) {
    // Remove hidden class
    menu.classList.remove('hidden');
    
    // Force display block with iOS fixes
    menu.style.cssText = 'display: block !important; visibility: visible !important; opacity: 1 !important; position: fixed !important; top: 0 !important; left: 0 !important; right: 0 !important; bottom: 0 !important; width: 100% !important; height: 100% !important; min-height: 100vh !important; z-index: 10000 !important; background-color: rgb(0, 0, 0) !important; -webkit-transform: translateZ(0) !important; transform: translateZ(0) !important;';
    
    // Force reflow to trigger animation
    menu.offsetHeight;
    
    // Prevent body scroll when menu is open (iOS fix)
    const scrollY = window.scrollY;
    document.body.style.cssText = 'overflow: hidden !important; position: fixed !important; width: 100% !important; height: 100% !important; top: ' + (-scrollY) + 'px !important;';
    document.documentElement.style.cssText = 'overflow: hidden !important; height: 100% !important;';
    document.body.classList.add('menu-open');
    document.documentElement.classList.add('menu-open');
    
    // Store scroll position for iOS
    if (window.scrollY) {
      menu.dataset.scrollY = window.scrollY;
    }
    
    // Ensure menu content is visible - force all styles
    const nav = menu.querySelector('nav');
    if (nav) {
      nav.style.cssText = 'display: flex !important; visibility: visible !important; opacity: 1 !important; z-index: 10001 !important; position: absolute !important; top: 0 !important; left: 0 !important; right: 0 !important; bottom: 0 !important; width: 100% !important; height: 100% !important; -webkit-transform: translateZ(0) !important; transform: translateZ(0) !important;';
    }
    
    const ul = menu.querySelector('nav ul');
    if (ul) {
      ul.style.cssText = 'display: block !important; visibility: visible !important; opacity: 1 !important; z-index: 10002 !important; position: relative !important; margin: 0 !important; padding: 0 !important; width: 100% !important;';
    }
    
    const menuItems = menu.querySelectorAll('nav ul li');
    menuItems.forEach(li => {
      li.style.cssText = 'display: block !important; visibility: visible !important; opacity: 1 !important;';
    });
    
    const menuLinks = menu.querySelectorAll('nav ul li a');
    menuLinks.forEach(link => {
      // Don't set color in inline style to allow hover to work
      link.style.cssText = 'display: block !important; visibility: visible !important; opacity: 1 !important; z-index: 2 !important; position: relative !important; pointer-events: auto !important; cursor: pointer !important; -webkit-tap-highlight-color: rgba(255, 255, 255, 0.1) !important; touch-action: manipulation !important;';
      // Set initial color via class, not inline style
      if (!link.style.color || link.style.color === '') {
        link.style.color = '#ffffff';
      }
      // Ensure links are clickable
      link.addEventListener('click', function(e) {
        e.stopPropagation();
      }, true);
      
      // Add hover effect via JavaScript for better compatibility
      // Each link has its own lottie container and animation instance
      const parentLi = link.parentElement;
      const lottieContainer = parentLi.querySelector('.mobile-menu-lottie-container');
      
      // Skip if no container found
      if (!lottieContainer) {
        return;
      }
      
      // Ensure parent li has position relative for absolute positioning
      if (parentLi && !parentLi.style.position) {
        parentLi.style.position = 'relative';
      }
      
      // Ensure lottie container is positioned correctly relative to its parent li
      if (lottieContainer && !lottieContainer.style.position) {
        lottieContainer.style.position = 'absolute';
        lottieContainer.style.top = '0%';
        lottieContainer.style.left = '50%';
        lottieContainer.style.transform = 'translateX(-50%)';
        lottieContainer.style.marginTop = '-20px';
      }
      
      // Hide all other animations when this link is hovered
      function hideAllOtherAnimations(currentContainer) {
        const allContainers = menu.querySelectorAll('.mobile-menu-lottie-container');
        allContainers.forEach(container => {
          if (container !== currentContainer) {
            container.style.display = 'none';
            // Pause animation if it exists
            if (container.lottieAnimInstance) {
              container.lottieAnimInstance.pause();
            }
          }
        });
      }
      
      function initLottieAnimation() {
        // Check if animation already exists on container
        if (lottieContainer.lottieAnimInstance) {
          return lottieContainer.lottieAnimInstance;
        }
        
        if (lottieContainer && typeof lottie !== 'undefined') {
          // Get animation path from window variable set in theme.liquid
          const animationPath = window.menuHoverAnimationPath || '/assets/menu-hover-animation.json';
          
          const lottieAnim = lottie.loadAnimation({
            container: lottieContainer,
            renderer: 'svg',
            loop: true,
            autoplay: false,
            path: animationPath
          });
          
          // Store animation instance on container for easy access
          lottieContainer.lottieAnimInstance = lottieAnim;
          return lottieAnim;
        }
        return null;
      }
      
      // Remove existing listeners if any (to prevent duplicates)
      const mouseEnterHandler = function() {
        this.style.color = '#FC0030';
        // Hide all other animations first
        hideAllOtherAnimations(lottieContainer);
        // Show and play Lottie animation for THIS specific link
        if (lottieContainer) {
          let lottieAnim = lottieContainer.lottieAnimInstance;
          if (!lottieAnim) {
            lottieAnim = initLottieAnimation();
          }
          if (lottieAnim) {
            lottieContainer.style.display = 'block';
            lottieAnim.play();
          }
        }
      };
      
      const mouseLeaveHandler = function() {
        this.style.color = '#ffffff';
        // Hide Lottie animation for THIS specific link
        if (lottieContainer && lottieContainer.lottieAnimInstance) {
          lottieContainer.style.display = 'none';
          lottieContainer.lottieAnimInstance.pause();
        }
      };
      
      const touchStartHandler = function() {
        this.style.color = '#FC0030';
        // Hide all other animations first
        hideAllOtherAnimations(lottieContainer);
        // Show and play Lottie animation on touch for THIS specific link
        if (lottieContainer) {
          let lottieAnim = lottieContainer.lottieAnimInstance;
          if (!lottieAnim) {
            lottieAnim = initLottieAnimation();
          }
          if (lottieAnim) {
            lottieContainer.style.display = 'block';
            lottieAnim.play();
          }
        }
      };
      
      const touchEndHandler = function() {
        setTimeout(() => {
          this.style.color = '#ffffff';
          // Hide Lottie animation for THIS specific link
          if (lottieContainer && lottieContainer.lottieAnimInstance) {
            lottieContainer.style.display = 'none';
            lottieContainer.lottieAnimInstance.pause();
          }
        }, 200);
      };
      
      // Store handlers on link for potential cleanup
      link._mouseEnterHandler = mouseEnterHandler;
      link._mouseLeaveHandler = mouseLeaveHandler;
      link._touchStartHandler = touchStartHandler;
      link._touchEndHandler = touchEndHandler;
      
      link.addEventListener('mouseenter', mouseEnterHandler);
      link.addEventListener('mouseleave', mouseLeaveHandler);
      link.addEventListener('touchstart', touchStartHandler);
      link.addEventListener('touchend', touchEndHandler);
    });
    
    // Force close button visibility
    const closeBtn = menu.querySelector('button[onclick="closeMobileMenu()"]');
    if (closeBtn) {
      closeBtn.style.cssText = 'display: block !important; visibility: visible !important; opacity: 1 !important; z-index: 10001 !important; position: absolute !important; top: 1.5rem !important; right: 1.5rem !important;';
    }
    
    // iOS Safari specific fix - force repaint
    setTimeout(function() {
      menu.style.display = 'none';
      menu.offsetHeight; // Trigger reflow
      menu.style.display = 'block';
    }, 0);
  }
}

function closeMobileMenu() {
  const menu = document.getElementById('mobile-menu');
  if (menu) {
    menu.classList.add('hidden');
    menu.style.opacity = '0';
    menu.style.visibility = 'hidden';
    menu.style.display = 'none';
    
    // Re-enable body scroll when menu is closed (iOS fix)
    const scrollY = menu.dataset.scrollY || 0;
    document.body.style.cssText = '';
    document.documentElement.style.cssText = '';
    document.body.classList.remove('menu-open');
    document.documentElement.classList.remove('menu-open');
    
    // Restore scroll position for iOS
    if (scrollY) {
      window.scrollTo(0, parseInt(scrollY));
    }
  }
}

// Global function for closing mobile menu
window.closeMobileMenu = closeMobileMenu;

// Global function for header button
window.toggleMobileMenu = function() {
  const menu = document.getElementById('mobile-menu');
  if (menu) {
    if (menu.classList.contains('hidden') || menu.style.display === 'none') {
      menu.style.display = 'block';
      openMobileMenu();
    } else {
      closeMobileMenu();
    }
  }
};

// Sayfa yüklendiğinde menünün kapalı olduğundan emin ol
window.addEventListener('load', function() {
  closeMobileMenu();
});

// Boş alana tıklayınca menüyü kapat ve link tıklamalarını yönet
document.addEventListener('DOMContentLoaded', function() {
  const mobileMenu = document.getElementById('mobile-menu');
  if (mobileMenu) {
    // Sayfa yüklendiğinde menünün kapalı olduğundan emin ol
    closeMobileMenu();
    
    // Menü container'ına tıklanınca (sadece boş alana) kapat
    mobileMenu.addEventListener('click', function(e) {
      // Eğer tıklanan element menü container'ı ise (boş alan) kapat
      if (e.target === mobileMenu) {
        closeMobileMenu();
      }
    });
    
    // Nav'e tıklanınca (sadece boş alana) kapat
    const nav = mobileMenu.querySelector('nav');
    if (nav) {
      nav.addEventListener('click', function(e) {
        // Eğer tıklanan element nav'in kendisi ise (boş alan) kapat
        if (e.target === nav) {
          closeMobileMenu();
        }
      });
      
      // Event delegation ile tüm link tıklamalarını yakala
      nav.addEventListener('click', function(e) {
        const link = e.target.closest('a');
        if (link && link.closest('#mobile-menu')) {
          // Link tıklandığında menüyü hemen kapat
          closeMobileMenu();
        }
      }, true);
    }
  }
});

// Search Popup Functions - Global
window.openSearchPopup = function() {
  const popup = document.getElementById('search-popup');
  if (popup) {
    // Save current scroll position
    const scrollY = window.scrollY || window.pageYOffset;
    popup.dataset.scrollY = scrollY;
    
    popup.classList.remove('hidden');
    popup.style.display = 'block';
    
    // Prevent body scroll - multiple methods for better mobile support
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = `-${scrollY}px`;
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.position = 'fixed';
    document.documentElement.style.width = '100%';
    document.body.classList.add('search-popup-open');
    document.documentElement.classList.add('search-popup-open');
    
    // Start typewriter animation first
    if (typeof startSearchTypewriter === 'function') {
      startSearchTypewriter();
    }
    
    // Focus on search input after a delay (so animation can start)
    setTimeout(() => {
      const input = document.getElementById('search-input');
      if (input && !input.value) {
        // Only focus if input is empty, so typewriter can continue
        input.focus();
      }
    }, 300);
  }
};

window.closeSearchPopup = function() {
  const popup = document.getElementById('search-popup');
  if (popup) {
    popup.classList.add('hidden');
    
    // Restore body scroll - restore scroll position
    const scrollY = popup.dataset.scrollY || 0;
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.top = '';
    document.documentElement.style.overflow = '';
    document.documentElement.style.position = '';
    document.documentElement.style.width = '';
    document.body.classList.remove('search-popup-open');
    document.documentElement.classList.remove('search-popup-open');
    
    // Restore scroll position
    if (scrollY) {
      window.scrollTo(0, parseInt(scrollY));
    }
    
    // Stop typewriter animation
    if (typeof stopSearchTypewriter === 'function') {
      stopSearchTypewriter();
    }
  }
};

window.handleSearchClick = function(e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  
  if (typeof window.openSearchPopup === 'function') {
    window.openSearchPopup();
  } else {
    // Retry after a short delay if function not loaded yet
    setTimeout(function() {
      if (typeof window.openSearchPopup === 'function') {
        window.openSearchPopup();
      }
    }, 200);
  }
};

// Product Images Container - Simple Native Scroll with CSS Snap
// Native scroll kullanarak daha basit ve performanslı çözüm
(function() {
  function initProductImagesScroll() {
    if (window.innerWidth > 1023) return;
    
    const productImagesGrid = document.getElementById('product-images-container');
    if (!productImagesGrid) {
      setTimeout(initProductImagesScroll, 200);
      return;
    }
    
    // Sadece CSS özelliklerini ayarla - native scroll kullan
    productImagesGrid.style.overflowX = 'auto';
    productImagesGrid.style.overflowY = 'hidden';
    productImagesGrid.style.scrollSnapType = 'x mandatory';
    productImagesGrid.style.scrollBehavior = 'smooth';
    productImagesGrid.style.webkitOverflowScrolling = 'touch';
    productImagesGrid.style.touchAction = 'pan-x';
    
    // Görsellerin onclick'lerini devre dışı bırak (mobilde)
    const images = productImagesGrid.querySelectorAll('img[onclick]');
    images.forEach(function(img) {
      img.removeAttribute('onclick');
      img.style.pointerEvents = 'none';
      img.style.touchAction = 'none';
    });
    
    console.log('Product images native scroll initialized');
  }
  
  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductImagesScroll);
  } else {
    setTimeout(initProductImagesScroll, 100);
  }
  
  // Re-initialize on resize
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      if (window.innerWidth <= 1023) {
        setTimeout(initProductImagesScroll, 100);
      }
    }, 250);
  });
})();

